import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';

import { TranslateModule } from '@ngx-translate/core';

import { MgButtonModule } from '@app/src/app/button';
import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { AddressModule } from '@app/src/app/components/Input/Address';
import { MgEmailModule } from '@app/src/app/components/Input/Email';
import { FileInputModule } from '@app/src/app/components/Input/FileInput';
import { FileUploadModule } from '@app/src/app/components/Input/FileUpload';
import { MingaNameModule } from '@app/src/app/components/Input/MingaName';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgDateTimePickerModule } from '@app/src/app/date-time-picker';
import { SaveCancelDialogModule } from '@app/src/app/dialog/SaveCancel';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgOverlayToolsModule } from '@app/src/app/overlay/tools';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { DestroyMingaDialogModule } from '@app/src/app/routes/sadmin/minga/DestroyMingaDialog';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { CollapsibleModule } from '@shared/components/collapsible';
import { FormModule } from '@shared/components/form';
import { MingaPartnerSearchDirective } from '@shared/components/form/directives/minga-partner-search.directive';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { ModalOverlayService, OverlayModule } from '@shared/components/modal-overlay';
import { TextModule } from '@shared/components/text';
import { ArrayPipesModule } from '@shared/pipes';

import { MmDashboardEditComponent } from './components/mm-dashboard-edit/mm-dashboard-edit.component';
import { MmDashboardModulesComponent } from './components/mm-dashboard-modules/mm-dashboard-modules.component';
import { MmDashboardTableComponent } from './components/mm-dashboard-table/mm-dashboard-table.component';
import { MmDashboardComponent } from './mm-dashboard.component';
import {
  MmDashboardFeatureToggleService,
  MmDashboardFiltersService,
  MmDashboardService,
  MmDashboardTableService,
} from './services';

@NgModule({
  imports: [
    // Minga dependencies
    MgEmptyStateModule,
    ManagerOverlayModule,
    CollapsibleModule,
    MgSpinnerModule,
    FormModule,
    MgIconModule,
    OverlayModule,
    PermissionsModule,
    MgPipesModule,
    MgImageModule,
    MgButtonModule,
    MgAvatarModule,
    MgDateTimePickerModule,
    MgEmailModule,
    AddressModule,
    MingaNameModule,
    FileUploadModule,
    FileInputModule,
    MgFormFieldModule,
    DestroyMingaDialogModule,
    SaveCancelDialogModule,
    MgOverlayToolsModule,
    ArrayPipesModule,
    GenericModule,
    TextModule,
    MgPipesModule,

    // External dependencies
    CommonModule,
    MatTableModule,
    MatSortModule,
    FlexLayoutModule,
    MatPaginatorModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatExpansionModule,
    TranslateModule,
    MatFormFieldModule,
    MatIconModule,
    MatTooltipModule,
  ],
  declarations: [
    MmDashboardComponent,
    MmDashboardTableComponent,
    MmDashboardEditComponent,
    MmDashboardModulesComponent,
  ],
  providers: [
    MmDashboardService,
    MmDashboardFiltersService,
    MmDashboardTableService,
    ModalOverlayService,
    MingaPartnerSearchDirective,
    MmDashboardFeatureToggleService,
    TitleCasePipe,
  ],
  exports: [MmDashboardComponent, MmDashboardModulesComponent],
})
export class MmDashboardModule {}
